// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1Hv3d","noInteraction":"EventWrapper_noInteraction__3Gw-w"};